(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PrefectureDeleteController',PrefectureDeleteController);

    PrefectureDeleteController.$inject = ['$uibModalInstance', 'entity', 'Prefecture'];

    function PrefectureDeleteController($uibModalInstance, entity, Prefecture) {
        var vm = this;
        vm.prefecture = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Prefecture.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
